import * as Actions from '../actions/walkthrough.actions';

var initialState = {
    active: false,
    currentStep: 0,
    completed: false,
    enabled: false
};

var walkthroughReducer = function (state, action) {
    if (state === undefined) state = initialState;

    switch (action.type) {
        case Actions.SET_WALKTHROUGH_ACTIVE:
            return Object.assign({}, state, { active: action.payload });
        case Actions.SET_WALKTHROUGH_STEP:
            return Object.assign({}, state, { currentStep: action.payload });
        case Actions.SET_WALKTHROUGH_COMPLETED:
            return Object.assign({}, state, { completed: action.payload });
        case Actions.SET_WALKTHROUGH_ENABLED:
            return Object.assign({}, state, { enabled: action.payload });
        case Actions.RESET_WALKTHROUGH:
            return Object.assign({}, initialState);
        default:
            return state;
    }
};

export default walkthroughReducer;
